import React, { useState } from "react";
import { AddNewSalesPost } from "../../../server/SalesManagement";
import Input from "../../containers/InputForm";
import { setPreload } from "../../../server/CartsOpen";
import { useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import StationsInSale from "./StationsInSale";
import showAlert from "../../../server/ShowAlert";
import { useLocation } from "react-router-dom";
import { TimeBigYearMonthDate } from "../../containers/Date";
import ProductInSale from "./ProductInSale";
import { NavLink } from "react-router-dom";
import { globalFileIcon } from "../../../../axiosInstance";
import { useNavigate } from "react-router-dom";

const schema = yup
  .object({
    description: yup
      .string()
      .required("כותרת חובה")
      .test("len", "אורך מקסימלי 50", (x) => x.length <= 50),
    // TypeId: yup.string().required("חובה להכניס סוג הנחה"),
    minQuantity: yup
      .number()
      .required("חובה להכניס כמות מינימאלית")
      .positive("חייב להיות מספר גדול מ 0")
      .test("maxDigits", "עד 2 ספרות אחרי הנקודה", (number) =>
        Number.isInteger(number * 10 ** 2),
      ),
    startDate: yup.string().required("חובה להכניס מתאריך "),
    endDate: yup.string().required("חובה להכניס עד תאריך "),
    Duplicates: yup
      .number()
      .required("חובה להכניס מספר כפולות ")
      .positive("חייב להיות מספר גדול מ 0")
      .test("maxDigits", "עד 2 ספרות אחרי הנקודה", (number) =>
        Number.isInteger(number * 10 ** 2),
      ),
    maxPerPeriod: yup
      .number()
      .required("חובה להכניס מספר מימושים ללקוח ")
      .positive("חייב להיות מספר גדול מ 0")
      .integer("חייב להיות מספר שלם"),
    discountValue: yup
      .number()
      .required("חובה להכניס מחיר ")
      .test(
        "maxDigits",
        "עד 2 ספרות אחרי הנקודה",
        (number) => number >= 0 && Number.isInteger(number * 10 ** 2),
      ),
  })
  .required();

const SalePage = () => {
  const navigate = useNavigate();
  const {
    state: { saleData },
  } = useLocation();
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors, dirtyFields },
    reset,
  } = useForm({
    defaultValues: {
      ...saleData,
      startDate: TimeBigYearMonthDate(saleData?.startDate || new Date()),
      endDate: TimeBigYearMonthDate(saleData?.endDate || new Date()),
    },
    resolver: yupResolver(schema),
  });
  const [sale, setSale] = useState(saleData);
  const checkedDates = (startDate, endDate) => {
    const toDay = new Date();
    if (new Date(startDate) > new Date(endDate)) {
      showAlert({
        msgTitle: "תאריך התחלה חייב להיות לפני תאריך סיום.",
        msgType: "error",
      });
      return false;
    }
    if (new Date(toDay).getDay() > new Date(startDate).getDay()) {
      showAlert({
        msgTitle: "לא ניתן להוסיף/לערוך מבצע שכבר התחיל.",
        msgType: "error",
      });
      return false;
    }
    return true;
  };

  const save = (data) => {
    const startDate = formatDate(data.startDate);
    const endDate = formatDate(data.endDate);

    if (!startDate || !endDate) {
      showAlert({ msgTitle: "יש להזין תאריכים תקינים", msgType: "error" });
      return;
    }

    const correctDate = checkedDates(startDate, endDate);
    if (!correctDate) {
      return;
    }
    if (correctDate) {
      data.startDate = new Date(data.startDate);
      data.endDate = new Date(data.endDate);

      dispatch(setPreload(true));

      AddNewSalesPost(data)
        .then((x) => {
          if (x.data) {
            setSale(x.data);
            reset(undefined, {
              dirtyFields: false,
              errors: true,
            });
            for (let item in x.data) {
              setValue(item, x.data[item]);
            }
            showAlert({ msgTitle: "המבצע נשמר בהצלחה", msgType: "success" });
            navigate("/sales-management");
          }
        })
        .catch((x) => {
          if (x.status === 400) {
            showAlert({ msgTitle: "שגיאת נתונים" });
          } else {
            showAlert({ msgTitle: "שגיאת נתונים" });
          }
        })
        .finally(() => dispatch(setPreload(false)));
    } else {
      showAlert({
        msgTitle: "המבצע כבר התחיל, לא ניתן לשנות הגדרות",
        msgType: "success",
      });
    }
  };

  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    if (isNaN(d)) return "";
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  return (
    <div className="add-new-sale">
      <h1 className="title-role">פרטי מבצע</h1>
      <form className="register" onSubmit={handleSubmit(save)}>
        <div className="sale-form">
          <div>
            <Input
              type="description"
              register={register}
              label="כותרת"
              errors={errors}
              name="description"
              dirtyFields={dirtyFields}
            />

            {/* <Input
                                    type="number"
                                    register={register}
                                    label="סוג מבצע"
                                    errors={errors}
                                    name="TypeId" /> */}

            <Input
              type="number"
              register={register}
              label="החל מ-  "
              errors={errors}
              name="minQuantity"
              dirtyFields={dirtyFields}
            />

            <Input
              type="number"
              register={register}
              label="כמות מינימלית"
              errors={errors}
              name="minQuantity"
              dirtyFields={dirtyFields}
            />

            <Input
              type="date"
              register={register}
              label="מתאריך"
              errors={errors}
              name="startDate"
              dirtyFields={dirtyFields}
              defaultValue={TimeBigYearMonthDate(getValues("startDate"))}
            />

            <Input
              type="date"
              register={register}
              label="עד תאריך"
              errors={errors}
              name="endDate"
              dirtyFields={dirtyFields}
              defaultValue={TimeBigYearMonthDate(getValues("endDate"))}
            />

            <Input
              type="number"
              register={register}
              label="כפולות"
              errors={errors}
              name="Duplicates"
              dirtyFields={dirtyFields}
            />

            <Input
              type="number"
              register={register}
              label="מימושים"
              errors={errors}
              name="maxPerPeriod"
              dirtyFields={dirtyFields}
            />

            <Input
              type="description"
              register={register}
              label="מחיר"
              errors={errors}
              name="discountValue"
              dirtyFields={dirtyFields}
            />
            <input className="btn" type="submit" value="שמור" />
          </div>
        </div>
      </form>
      {sale ? (
        <div className="station-and-product-in-sale">
          <StationsInSale sale={sale} checkedDates={checkedDates} />
          <ProductInSale sale={sale} checkedDates={checkedDates} />
        </div>
      ) : null}
      <NavLink className="go-back-to-sale-list" to={"/sales-management"}>
        <img
          loading="lazy"
          src={globalFileIcon + "arrowSide.svg"}
          alt="arrowSide"
        />
      </NavLink>
    </div>
  );
};
export default SalePage;
